var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2931 7.96264C31.0758 7.96909 30.8696 8.05958 30.7181 8.21492L8.24445 30.6067C8.16418 30.6835 8.1001 30.7754 8.05595 30.8772C8.0118 30.979 7.98848 31.0885 7.98735 31.1994C7.98622 31.3103 8.0073 31.4202 8.04936 31.5229C8.09142 31.6255 8.15361 31.7188 8.2323 31.7972C8.31098 31.8756 8.40458 31.9375 8.5076 31.9795C8.61062 32.0214 8.721 32.0424 8.83227 32.0412C8.94355 32.0401 9.05347 32.0169 9.15562 31.9729C9.25776 31.9289 9.35007 31.865 9.42714 31.7851L31.9008 9.39331C32.0216 9.27625 32.1042 9.12555 32.1376 8.96095C32.171 8.79635 32.1538 8.62553 32.0881 8.47088C32.0224 8.31622 31.9113 8.18495 31.7695 8.09426C31.6276 8.00357 31.4616 7.95769 31.2931 7.96264Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0733 3.33337C10.8448 3.33337 3.3457 10.8052 3.3457 20C3.3457 29.1949 10.8448 36.6667 20.0733 36.6667C29.3018 36.6667 36.8009 29.1949 36.8009 20C36.8009 10.8052 29.3018 3.33337 20.0733 3.33337ZM20.0733 5.00004C28.3978 5.00004 35.1282 11.7059 35.1282 20C35.1282 28.2942 28.3978 35 20.0733 35C11.7488 35 5.01846 28.2942 5.01846 20C5.01846 11.7059 11.7488 5.00004 20.0733 5.00004Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.583d996275250b8c1d006071b43f532a.svg";
export { ForwardRef as ReactComponent };